import { render, staticRenderFns } from "./ArticleInfoNormalTemplate.vue?vue&type=template&id=ce40c4b4&scoped=true"
import script from "./ArticleInfoNormalTemplate.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoNormalTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoNormalTemplate.vue?vue&type=style&index=0&id=ce40c4b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce40c4b4",
  null
  
)

export default component.exports